module.exports = __webpack_public_path__ + "img/BI.4789ccae.svg";